module.exports = __webpack_public_path__ + "static/media/msu_logo.cdf38bd4.svg";